import React from "react";
import noun_basket_3368367 from '../assets/images/noun_basket_3368367.png';
import noun_arrow_6402 from '../assets/images/noun_arrow_6402.png';
import { Link } from "react-router-dom";
import { useTranslation,Trans } from 'react-i18next';

function Startorder() {
  
  return (
    <div className="pagelanding_r">
                <div className="landingpage_slider_r col-3">
                       <Link to="/menu"> <img src={noun_basket_3368367} className="noun_basket_3368367" alt="noun_basket_3368367" width="33" height="31"/>
                        <p className="text-12"><Trans
                                    i18nKey="start_order_txt"
                                    components={{ br: <br /> }}
                                /></p>
                        <img src={noun_arrow_6402} className="noun_arrow_6402" alt="noun_arrow_6402" width="42" height="40"/></Link>
                    </div>
              </div>

    );
}

export default Startorder;
